<div class="sense-shell">
  <!-- B5: shared check-in progress header (step 4 of 4). -->
  <app-checkin-progress [step]="4"></app-checkin-progress>
  <iframe
    #frame
    *ngIf="srcdoc"
    class="sense-frame"
    [srcdoc]="srcdoc"
    [title]="'miscUi.senseFrameTitle' | translate"
    allow="autoplay"
  ></iframe>

  <app-loader variant="thankyou" *ngIf="saving"></app-loader>
</div>
